
    import Vue from "vue";
    import {Ripple} from "vuetify/lib/directives/";
    import {ChevronDownIcon, ChevronUpIcon} from 'vue-feather-icons';
    import {mask} from "vue-the-mask";

    import RomaMessageModal from "../../commons/RomaMessageModal.vue";
    import RomaConfirmDialog from "../../commons/RomaConfirmDialog.vue";
    import RomaActivityModalForm from "../activity/RomaActivityModalForm.vue";
    import UnitPlanOa from "../../../store/planner/objetive/UnitPlanOa";
    import UnitPlanActivityIe from "../../../store/planner/activity/UnitPlanActivityIe";
    import UnitPlan from '../../../store/units/UnitPlan';
    import UnitPlanComments from '../../../store/units/UnitPlanComments';

    function onlyUnique(value: any, index: number, self: any) {
  return self.indexOf(value) === index;
}

// @ts-ignore
export default Vue.extend({
  name: "RomaOa",
  props: {
    noDataText: {
      type: String,
      required: false
    },
    test: {
      type: Boolean
    },
    changeOas: {
      type: Array | Object,
      default() {
        return {};
      }
    },
    unit: {
      type: Object,
      required: true
    },
    prioritySelected: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: "564"
    },
    elevation: {
      type: Boolean,
      default: true
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideBadges: {
      type: Boolean,
      default: false
    },
    hideFilters: {
      type: Boolean,
      default: false
    },
    applyRowColor: {
      type: Boolean,
      default: true
    }
  },
  beforeCreate: function () {
    this.$options.components.RomaOaModalForm = require('./RomaOaModalForm.vue').default
  },
  data() {
    return {
      filterBy: {
        field: '',
        value: 0,
      },
      parcialRequest: {
        idPlanUnidadOA: 0,
        idPlanUnidad: 0,
      },
      totalHours: '',
      loading: false,
      selectedIEsForActivities: [],
      userPrivileges: this.$store.state.user.privileges,
      filter: {
        crit: null,
        disabled: false,
      },
      pageCount: 0,
      dialog: false,
      messageDialog: false,
      selectedAll: false,
      dialogDeleteOA: false,
      dialogActivity: false,
      oaToDelete: null,
      selectedRows: [],
      expanded: [],
      buttons: [
        {
          disabled: false,
          label: 'activitiesButtonLabel',
          icon: 'fas fa-user-check',
          onClick: () => {
            this.selectedIEsForActivities = this.selectedRows.slice();
            this.dialogActivity = true;
          },
          enable: this.$store.state.user.privileges
            .canSeeUnitCoverageAndActivities
        },
        {
          disabled: false,
          label: 'activateOrInactivateButtonLabel',
          icon: 'fas fa-times-circle',
          onClick: () => {
            this.toggleOa(this.selectedRows);
          },
          enable: this.$store.state.user.privileges
            .canEditPurposeAndAddOrRemoveOAs
        },
        {
          disabled: false,
          label: 'reprogramButtonLabel',
          icon: 'fas fa-times-circle',
          onClick: () => {
            this.toggleOa(this.selectedRows, true);
          },
          enable: this.$store.state.user.privileges
            .canEditCoverageAndActivitiesAndReprogramOAAndAdvanceAndComment && (this.unit.plan_status_id === 1 || this.unit.plan_status_id === 2)
        }
      ],
      oaDetails: [
        {
          name: "activitiesOf",
          icon: "fas fa-user-check",
          prop: "activities",
          color: "secondary",
          count: (item: any) => {
            return this.activitiesInOa(item.oa);
          },
          onClick: (item: any) => {
            this.$store.commit("highlightWords", item.oa.cod);
            this.goActivityTab();
          },
          enable: this.$store.state.user.privileges
            .canSeeUnitCoverageAndActivities
        },
        {
          name: "commentsOf",
          icon: "fas fa-comment",
          prop: "comments",
          color: "primary",
          count: (item: any) => {
            return UnitPlanComments.query().where('idPlanUnidadOA', item.id).count();
          },
          onClick: (item: any) => {
            this.messageDialog = true;
            this.parcialRequest = {
              idPlanUnidadOA: item.id,
              idPlanUnidad: this.unit.id,
            };
            this.filterBy = {
              field: 'idPlanUnidadOA',
              value: item.id,
            };
          },
          enable: this.$store.state.user.privileges.canSeeComments
        }
      ],
      headerOAs: [
        {
          text: "",
          align: "left",
          value: "oa.id"
        },
        { text: "Nombre", value: "oa.name" },
        { text: "Comentarios", value: "oa.comments" },
        { text: "", sortable: false },
        { text: "", value: "data-table-expand", sortable: false },
        {
          text: "",
          value: "oa.disabled",
          sortable: false,
          filter: (value: boolean, search: string, item: any) => {
            if (
              !this.filter ||
              this.filter.disabled === null ||
              this.filter.disabled === undefined
            )
              return true;
            return (
              this.filter.disabled ===
              (item.disabled ||
                (this.filter.disabled &&
                  item.oa.ies.some((ie: any) => ie.disabled)))
            );
          }
        }
      ],
      headerIEs: [
        { text: "ID", value: "id" },
        { text: "Nombre", value: "name" },
        { text: "", value: "editIE" },
        {
          text: "",
          value: "ie.disabled",
          sortable: false,
          filter: (value: boolean, search: string, item: any) => {
            if (
              !this.filter ||
              this.filter.disabled === null ||
              this.filter.disabled === undefined
            )
              return true;
            return this.filter.disabled === item.disabled;
          }
        }
      ]
    };
  },
  computed: {
    isIndeterminate() {
      let opt = false;
      if (
        this.selectedRows.length !== this.unit.oas.length &&
        this.selectedRows.length !== 0
      )
        opt = true;
      return opt;
    },
    totalSelectedIEs() {
      let sum = 0;
      if (this.selectedRows.length > 0) {
        sum = this.selectedRows.map(oa => oa.selectedRows.length);
        sum = sum.reduce((a, b) => a + b);
      }

      return sum;
    },
    oasAdded() {
      if (this.test) {
        return this.orderOas(this.changeOas.details);
      } else {
        return this.orderOas(UnitPlanOa.getAllByPlanUnidad(this.unit.id))
      }
    }
  },
  watch: {
    oasAdded: {
      immediate: true,
      handler() {
        this.selectedRows = [];
        this.setHour();
      },
    },
    selectedRows: {
      deep: true,
      handler(value) {
        if (value.length === 0) this.selectedAll = false;
        this.$emit("oa-selected", this.selectedRows);
      }
    },
    filter: {
      deep: true,
      handler(value) {
        if (value.disabled === undefined) value.disabled = null;
        if (!value.crit) value.crit = "";
        this.$set(this.filter, "crit", value.crit);
      }
    }
  },
  methods: {
    orderOas(oas:any){
      return oas.sort(
        function (a:any, b:any) {
          if (a.oa.cod_eje > b.oa.cod_eje) { return 1; }
          if (a.oa.cod_eje < b.oa.cod_eje) { return -1; }
          return 0;
        }
      )
    },
    checkTotals(total1: string, total2: string): boolean {
      return Number.parseInt(total1) > Number.parseInt(total2);
    },
    setHour() {
      if (!Array.isArray(this.oasAdded)) return;
      let h = 0;

      const hours = this.oasAdded
        .filter((item: any) => !!item.hours && !item.disabled)
        .map((item: any) => item.hours);

      h = hours.reduce(
        (acumulator: number, hour: string) =>
          acumulator + Number.parseInt(hour),
        0
      );

      this.totalHours = h === 1
        ? `${h} ${this.$vuetify.lang.t('$vuetify.component.romaOA.hour')}`
        : `${h} ${this.$vuetify.lang.t('$vuetify.component.romaOA.hours')}`;
    },
    saveHours() {
      this.loading = true;
      const saveHours: any[] = this.oasAdded.map(upOA => {
        return {
          id: upOA.id,
          horas: upOA.hours
        };
      });
      this.$store.dispatch("saveHours", saveHours).then(response => {
        let msj = {
          show: true,
          text: "",
          color: "success"
        };
        if (
          response.data &&
          response.data.status &&
          response.data.status.code === 1
        ) {
          msj.text = this.$vuetify.lang.t('$vuetify.component.romaOA.endpointMessages.saveHoursSuccess');
          UnitPlanOa.update({ data: this.oasAdded });
          this.unit.updateStatus(response.data.content.statusTO);
          UnitPlan.update({ data: this.unit });
          const commentsToInsert = response.data.content.comments.filter((comment: any) => !!comment);
          if (commentsToInsert.length > 0) UnitPlanComments.insert({ data: commentsToInsert });
        } else if (
          response.data &&
          response.data.status &&
          response.data.status.code === 3
        ) {
          msj.text = response.data.content.message;
          msj.color = "red";
        } else {
          msj.show = false;
        }

        this.$store.state.snackbar = msj;
        this.loading = false;
      });
    },
    setPageCount(count) {
      this.pageCount = count;
    },
    goActivityTab() {
      this.$nextTick(() => {
        this.selectedRows = [];
        window.location.hash = "tab-3";
      });
    },
    selectOA({ item, value }) {
      item.selectedRows = value ? item.oa.ies : []; // Selecciona todos los ies de un oa
      item.changeStatus = value;
    },
    selectAllOAs() {
      if (this.selectedAll) {
        this.selectedRows = this.oasAdded;
        this.selectedRows.forEach(detail => {
          detail.selectedRows = detail.oa.ies;
          detail.changeStatus = true;
        });
      } else {
        this.selectedRows.forEach(detail => {
          detail.selectedRows = [];
        });
        this.selectedRows = [];
      }
    },
    selectIE(oa: object, { value }) {
      const index = this.selectedRows.indexOf(oa);
      if (value) {
        if (index === -1) this.selectedRows.push(oa); // agrega a oa seleccionado si se marca un ie
      } else {
        if (oa.selectedRows.length === 1) {
          this.selectedRows.splice(index, 1); // Si deshabilita el ultimo ie quito el oa de seleccionado
        }
      }
    },
    async toggleOa(unitPlanOAs, reprogram: boolean = false) {
      this.loading = true;
      this.buttons[1].disabled = true;
      this.buttons[2].disabled = true;
      if (Array.isArray(unitPlanOAs)) {
        let toggleOATOList: any[] = [];
        let IEIds: number[] = [];

        unitPlanOAs.forEach(upOA => {
          toggleOATOList.push({
            idPlanUnidadOA: upOA.id,
            changeStatus: upOA.changeStatus
          });
          IEIds = IEIds.concat(upOA.selectedRows.map(ie => ie.id));
        });

        const toggle: any = {
          toggleOATOList: toggleOATOList,
          ieids: IEIds,
          reprogram,
          dontChangeStatus: false,
        };

        const response = await this.$store.dispatch("toggleUnitPlanOA", toggle);
        let msj = {
          show: true,
          text: "",
          color: "success"
        };
        if (
          response.data &&
          response.data.status &&
          response.data.status.code === 1
        ) {
          const propertyToToggle: string = toggle.reprogram ? 'rescheduled' : 'disabled';
          msj.text = reprogram
            ? this.$vuetify.lang.t('$vuetify.component.romaOA.endpointMessages.reprogramSuccess')
            : this.$vuetify.lang.t('$vuetify.component.romaOA.endpointMessages.changeStatusSuccess');
          unitPlanOAs.forEach(upOA => {
            if (upOA.changeStatus) upOA[propertyToToggle] = !upOA[propertyToToggle];
            upOA.selectedRows.forEach(ie => {
              if (upOA.changeStatus) {
                ie[propertyToToggle] = upOA[propertyToToggle];
              } else {
                ie[propertyToToggle] = !ie[propertyToToggle];
              }
              if (!!ie.rescheduled) ie.disabled = true;
            });
            if (!upOA.changeStatus)
              upOA[propertyToToggle] = upOA.oa.ies.every(ie => ie[propertyToToggle]);
            delete upOA.changeStatus;
            upOA.selectedRows = [];
            if (!!upOA.rescheduled) upOA.disabled = true;
          });
          this.selectedRows = [];
          UnitPlanOa.update({ data: unitPlanOAs });
          this.unit.updateStatus(response.data.content.status);
          this.unit.updatePercentages(response.data.content.percentages);
          const commentsToInsert = response.data.content.comments.filter((comment: any) => !!comment);
          if (commentsToInsert.length > 0) UnitPlanComments.insert({ data: commentsToInsert });
        } else if (
          response.data &&
          response.data.status &&
          response.data.status.code === 3
        ) {
          msj.text = response.data.content.message;
          msj.color = "red";
        } else {
          msj.text = this.$vuetify.lang.t('$vuetify.generals.endpointMessages.notProcessed');
          msj.color = "red";
        }

        this.$store.state.snackbar = msj;
      }
      this.buttons[1].disabled = false;
      this.buttons[2].disabled = false;
      this.loading = false;
    },
    goDelOA(oa) {
      this.dialogDeleteOA = true;
      this.oaToDelete = oa;
    },
    delOA() {
      UnitPlanOa.delete(this.oaToDelete.id);

      this.oaToDelete = null;
      this.dialogDeleteOA = false;
    },
    activitiesInOa(oa) {
      let upaIEs: UnitPlanActivityIe[] = UnitPlanActivityIe.query()
        .with("ie", query => {
          query.where("oa_id", oa.id);
        })
        .get();
      upaIEs = upaIEs
        .filter((upaIE: any) => !!upaIE.ie)
        .map((upaIE: any) => upaIE.activity_id)
        .filter(onlyUnique);
      return upaIEs.length;
    },
    customFilter(value, search, item) {
      search = search.toLowerCase();
      return (
        item.oa.cod.toLowerCase().indexOf(search) > -1 ||
        item.oa.name.toLowerCase().indexOf(search) > -1
      );
    },
    rowStyle(itemIndex: number, disabled: boolean = false) {
      const colors = [
        "--v-roma_rcolor-lighten3",
        "--v-primary-base",
        "--v-secondary-base",
        "--v-roma_acolor-base"
      ];
      let color = `var(${colors[itemIndex % colors.length]})`;

      if (disabled) color = "grey";
      if (!this.applyRowColor) return false;

      return color;
    }
  },
  components: {
    RomaMessageModal,
    RomaConfirmDialog,
    RomaActivityModalForm,
    ChevronDownIcon,
    ChevronUpIcon
  },
  directives: {
    mask,
    Ripple
  }
});
